import { useState } from "react";

const useEditorState = ({ currentUrl, berangkatUrlPart }) => {
  // data state
  const [pengecekanSaved, setPengecekanSaved] = useState({
    bagian_depan: false,
    bagian_samping: false,
    bagian_belakang: false,
    bagian_dalam: false,
  });

  const [pengecekanPertama, setPengecekanPertama] = useState(false);

  const [isBerangkat, setIsBerangkat] = useState(
    currentUrl.includes(berangkatUrlPart)
  );

  const [modeAmbilGambar, setModeAmbilGambar] = useState(false);

  const [headerData, setHeaderDataRaw] = useState({
    tanggal_transaksi: new Date(),
    tanggal_transaksi_jam: new Date(),
    tanggal_berangkat: undefined,
    tanggal_kembali: undefined,
    jumlah_orang: 0,
    speedo_mulai: 0,
    speedo_akhir: 0,
    keterangan: "",
  });
  const [headerError, setHeaderError] = useState({});
  // the header as the server last sent it (loaded / saved), to tell unsaved changes
  const [savedHeader, setSavedHeader] = useState(null);

  // supir berangkat and supir pulang share one error (at least one of them must be filled)
  const sharedErrorFields = ["data_supir", "data_supir_pulang"];

  // an input drops the error of the fields it changed
  const setHeaderData = (newData) => {
    setHeaderDataRaw(newData);

    setHeaderError((oldError) => {
      if (Object.keys(oldError).length === 0) return oldError;

      const changed = Object.keys(newData).filter(
        (key) => newData[key] !== headerData[key]
      );
      if (changed.some((key) => sharedErrorFields.includes(key))) {
        changed.push(...sharedErrorFields);
      }

      if (!changed.some((key) => key in oldError)) return oldError;

      const newError = { ...oldError };
      changed.forEach((key) => delete newError[key]);
      return newError;
    });
  };

  const [showBerangkat, setShowBerangkat] = useState(!isBerangkat);

  const [pengecekanBerangkatData, setPengecekanBerangkatData] = useState();
  const [pengecekanKembaliData, setPengecekanKembaliData] = useState();

  const [pengecekanBerangkatDetilData, setPengecekanBerangkatDetilData] =
    useState([]);
  const [pengecekanKembaliDetilData, setPengecekanKembaliDetilData] = useState(
    []
  );

  const [listProblemData, setListProblemData] = useState([]);

  return {
    pengecekanSaved,
    setPengecekanSaved,
    pengecekanPertama,
    setPengecekanPertama,
    isBerangkat,
    setIsBerangkat,
    modeAmbilGambar,
    setModeAmbilGambar,
    headerData,
    setHeaderData,
    headerError,
    setHeaderError,
    savedHeader,
    setSavedHeader,
    showBerangkat,
    setShowBerangkat,
    pengecekanBerangkatData,
    setPengecekanBerangkatData,
    pengecekanKembaliData,
    setPengecekanKembaliData,
    pengecekanBerangkatDetilData,
    setPengecekanBerangkatDetilData,
    pengecekanKembaliDetilData,
    setPengecekanKembaliDetilData,
    listProblemData,
    setListProblemData,
  };
};

export default useEditorState;
